import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClients } from './useApi';
import type { OAuthClient, CreateClientResult, RotateClientResult } from '../api/clients';

export function useClients() {
  const api = useApiClients();
  const qc = useQueryClient();

  const query = useQuery<OAuthClient[]>({
    queryKey: ['clients'],
    queryFn: async () => {
      const res = await api!.clients.list();
      return res.clients;
    },
    enabled: api !== null,
    staleTime: 10_000,
  });

  const createMut = useMutation<CreateClientResult, Error, string>({
    mutationFn: (name: string) => api!.clients.create(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });

  const rotateMut = useMutation<RotateClientResult, Error, string>({
    mutationFn: (clientId: string) => api!.clients.rotate(clientId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });

  const deleteMut = useMutation<{ client_id: string; deleted: boolean }, Error, string>({
    mutationFn: (clientId: string) => api!.clients.remove(clientId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });

  return {
    clients: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    create: createMut,
    rotate: rotateMut,
    remove: deleteMut,
  };
}